<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {PRODUCT_NAME} from '@/utils/extraServices/extra-services-const'

    @Component
    export class ExtraServiceStoreMixin extends Vue {
        get productStore() {
            return extraServicesStore
        }

        get productRuntimeStore() {
            return extraServicesRuntimeStore
        }

        get productType() {
            return 'extraService'
        }

        get productName() {
            return PRODUCT_NAME
        }
    }

    export default ExtraServiceStoreMixin
</script>
